import { Box, Typography } from "@mui/material";

export const HEAT_STATUS_COLORS = {
	P: "#DFFAE7", // Passed
	R: "#FCF3D6", // Re-Test
	U: "#FBDFE1", // No test yet
} as const;

const ITEMS = [
	{ color: HEAT_STATUS_COLORS.P, label: "Passed" },
	{ color: HEAT_STATUS_COLORS.R, label: "Re-Test" },
	{ color: HEAT_STATUS_COLORS.U, label: "No Test" },
];

// AG Grid custom status panel: color legend for the row backgrounds.
export const HeatStatusLegend = () => (
	<Box sx={{ display: "flex", alignItems: "center", gap: 1.5, py: 0.5 }}>
		{ITEMS.map((item) => (
			<Box
				key={item.label}
				sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
			>
				<Box
					sx={{
						width: 12,
						height: 12,
						borderRadius: 0.5,
						border: "1px solid #ccc",
						backgroundColor: item.color,
					}}
				/>
				<Typography sx={{ fontSize: "0.7rem", color: "#555" }}>
					{item.label}
				</Typography>
			</Box>
		))}
	</Box>
);
